import { Tooltip } from '@fullstory/components';
import React, { PropsWithChildren } from 'react';

interface ReferencesTooltipProps {
  objectId: string;
  tooltipContent: (objectId: string) => React.ReactNode;
}

export const ReferencesTooltip: React.FC<PropsWithChildren<ReferencesTooltipProps>> = ({
  objectId,
  children,
  tooltipContent,
}) => (
  <Tooltip
    data-component="ReferencesTooltip"
    tooltipContent={tooltipContent(objectId)}
    placement="bottom"
    showDelay={300}
    persistDelay={100}
    maxWidth={400}
    variant="light"
  >
    {children}
  </Tooltip>
);
